import { Avatar, Pagination } from "antd";
import { FiEdit2 } from "react-icons/fi";
import { Button, Card, CardBody, Table } from "reactstrap";
import CountButton from "../button/CountButton";
import TableSkeleton from "../skeleton/TableSkeleton";

const ProductsOfMfg = ({
  loadingProducts,
  products,
  getPartNumber,
  page,
  totalItems,
  setPage,
  pageSize,
  setPageSize,
  onEdit,
}) => {
  return (
    <Card className="settings-card shadow-sm border-0 mb-5">
      <CardBody className="p-4">
        <CountButton title="Products" count={products?.length} />
        {loadingProducts ? (
          <div className="mt-3">
            <TableSkeleton columns={6} />
          </div>
        ) : (
          <div className="modern-table-container p-0">
            <Table responsive className="modern-table mb-0">
              <thead>
                <tr>
                  <th className="text-center">Image</th>
                  <th className="text-center">SKU</th>
                  <th className="text-center">Part #</th>
                  <th className="text-center">Product Title</th>
                  <th className="text-right">Price</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {products?.length > 0 ? (
                  products.map((row, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <Avatar
                          src={row?.imageUrl || ""}
                          size={40}
                          className="shadow-sm border"
                          shape="square"
                        />
                      </td>
                      <td className="text-center">
                        <span className="user-badge bg-secondary-soft text-dark">
                          {row.sku}
                        </span>
                      </td>
                      <td className="text-center fw-500">
                        {getPartNumber(row) || "N/A"}
                      </td>
                      <td className="fw-bold small" style={{ maxWidth: '300px', whiteSpace: 'normal' }}>
                        {row?.name}
                      </td>
                      <td className="text-right fw-bold text-primary">
                        {row.price ? `$ ${row?.price}` : "N/A"}
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-center gap-2">
                          <Button
                            className="btn-action btn-edit"
                            onClick={() => onEdit && onEdit(row)}
                            title="Edit Product"
                          >
                            <FiEdit2 />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5 text-muted">
                      No products found for this manufacturer.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {products?.length > 0 && (
              <div className="d-flex justify-content-end align-items-center mt-4 pt-3 border-top">
                <Pagination
                  current={page}
                  total={totalItems}
                  pageSize={pageSize}
                  size="small"
                  onChange={(page, size) => {
                    setPage(page);
                    if (size !== pageSize) setPageSize(size);
                  }}
                  showSizeChanger={false}
                />
              </div>
            )}
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default ProductsOfMfg;
